import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { publicIpv4 } from 'public-ip';

@Injectable({
  providedIn: 'root'
})
export class VendorBackendService {

  private baseURL: string = environment.node_api_base_url
  headers: any = {};

  constructor(public http: HttpClient) {
  }

  Get<T>(key, params?, options = {}): Observable<T> {
    const url = this.resolveUrl(key);
    options = { ...options, params: params || {} };
    return this.http.get<T>(url, options);
  }

  Put(key, params, options = {}): Observable<any> {
    const url = this.resolveUrl(key);
    return this.http.put(url, params || {}, options);
  }

  Post(key, params, options = {}): Observable<any> {
    const url = this.resolveUrl(key);
    return this.http.post(url, params || {}, options);
  }

  GetAPICall(key, token = '', params?): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    if (params) {
      options['params'] = params
    }
    return this.http.get<any>(url, options);
  }

  PostAPICall(key, params, token = ''): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.post(url, params || {}, options);
  }

  PostInstanceAPICall(key, params, token = ''): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'enctype': 'multipart/form-data',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.post(url, params || {}, options);
  }


  PostExternalAPICall(url, params, token?): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.post(url, params || {}, options);
  }

  postApiTermsCall(key, payload, token) {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders();
    if (token) {
      httpHeaders = new HttpHeaders({
        'Authorization': 'Bearer ' + token
      });
    }
    let options = {
      headers: httpHeaders
    };
    return this.http.post(url, payload, options);
  }

  PostExternalTokenAPICall(url, params, token?): Observable<any> {
    let httpHeaders = new HttpHeaders();
    let options = {
      headers: httpHeaders
    };
    return this.http.post(url, params || {}, options);
  }

  PostExternalTokenUpdatedAPICall(url, params, token?): Observable<any> {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.post(url, params || {}, options);
  }

  PutAPICall(key, params, token = ''): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.put(url, params || {}, options);
  }

  PutInstanceAPICall(key, params, token = ''): Observable<any> {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders({
      'enctype': 'multipart/form-data',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.put(url, params || {}, options);
  }

  DeleteAPICall(endpoint, token = ''): Observable<any> {
    const url = this.baseURL + `${endpoint}`;
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.delete(url, options);
  }

  fileUpload(key, method, params, token = '') {
    const url = this.resolveUrl(key);
    let httpHeaders = new HttpHeaders();
    if (token) {
      httpHeaders = new HttpHeaders({
        'Authorization': 'Bearer ' + token
      });
    }
    let options = {
      headers: httpHeaders
    };
    if (method == "post") {
      return this.http.post(url, params || {}, options);
    } else if (method == "put") {
      return this.http.put(url, params || {}, options);
    }

  }

  getUserIp<T>(): Observable<T> {
    return new Observable<T>((observer) => {
      publicIpv4().then((ip) => {
        let e={'ip':ip}
        observer.next(e as T);
        observer.complete();
      }).catch((error) => {
        observer.error(error);
      });
    });
  }

  resolveUrl(key) {
    let url = '';
    this.urlHub().forEach(element => {
      if (element.api.filter(f => f === key).length) {
        url = `${element.baseUrl}/${element.route}/${key}`;
      }
    });
    return url;
  }

  // Subscribe(params): Observable<any> {
  //   const url = this.baseURL + "/api/users/subscribe";
  //   let httpHeaders = new HttpHeaders({
  //     'Content-Type' : 'application/json',
  //     'Cache-Control': 'no-cache'
  //   });
  //   let options = {
  //     headers: httpHeaders
  //   };
  //   return this.http.post(url, params || {}, options);
  // }

  urlHub() {
    return [
      {
        api: [
          'register',
          'setPassword',
          'login',
          'generateQR',
          'storeQR',
          'disableQR',
          'getProfileInfo',
          'updateProfileInfo',
          'getProfileImage',
          'updateProfileImage',
          'saveProfileImage',
          'forgotPassword',
          'resetPassword',
        ],
        baseUrl: this.baseURL,
        route: 'vendors/users',
      },
      {
        api: [
          'securityQuestions'
          // 'getViews'
        ],
        baseUrl: this.baseURL,
        route: 'api/users',
      },
      {
        api: [
          // 'getApiOrganization',
          // 'editApiOrganization',
          // 'updateApiOrganization',
          // 'delApiOrganization',
          // 'updateCompanyLogo',
          // 'getLogoImage',
          // 'saveCompanyLogo',
          // 'getProfileInfo',
          // 'updateProfileInfo'
        ],
        baseUrl: this.baseURL,
        route: 'api/organization',
      },      
      {
        api: [
          'getAllCountries',
        ],
        baseUrl: this.baseURL,
        route: 'api/countries',

      },
      // {
      //   api: [
      //     'saveSubscription',
      //     'getInvoiceList',
      //     'getPaymentList',
      //     'getBillingInfo',
      //     'getCurrentPlan',
      //     'getDashboardDetails',
      //     'getProductList',
      //     'getSessionChekoutStatus',
      //     'updatePaymentInfo'
      //   ],
      //   baseUrl: this.baseURL,
      //   route: 'api/payment'
      // }
    ];
  }
}

